import { createApi } from '@reduxjs/toolkit/query/react';
import { networkBaseQueryV2 } from './queries';

export const companyAtsApi = createApi({
  reducerPath: 'companyAtsApi',
  baseQuery: networkBaseQueryV2,
  tagTypes: ['company-ats'],
  endpoints: (builder) => ({
    getGemProjects: builder.query({
      query: ({ companyId }) => ({ url: `organizations/${companyId}/ats_data/projects` }),
      transformResponse: (response) => ({ projects: response?.projects ?? [] }),
      providesTags: (_result, _error, { companyId }) => [{ type: 'company-ats', id: `projects-${companyId}` }],
    }),
    getGemUsers: builder.query({
      query: ({ companyId }) => ({ url: `organizations/${companyId}/ats_data/users` }),
      transformResponse: (response) => ({ users: response?.users ?? [] }),
      providesTags: (_result, _error, { companyId }) => [{ type: 'company-ats', id: `users-${companyId}` }],
    }),
    getCompanyAtsSyncStatus: builder.query({
      query: ({ companyId }) => ({ url: `organizations/${companyId}/ats_sync_status` }),
      transformResponse: (response) => ({
        total: response?.total ?? 0,
        byStatus: response?.by_status ?? response?.byStatus ?? {},
      }),
      providesTags: (_result, _error, { companyId }) => [{ type: 'company-ats', id: `sync-status-${companyId}` }],
    }),
    getCompanyAtsKey: builder.query({
      query: ({ companyId }) => ({ url: `organizations/${companyId}/ats_api_key` }),
      transformResponse: (response) => ({
        hasKey: response?.hasKey ?? false,
        provider: response?.provider ?? null,
        gemProjectId: response?.gemProjectId ?? response?.gem_project_id ?? null,
        gemUserId: response?.gemUserId ?? response?.gem_user_id ?? null,
      }),
      providesTags: (_result, _error, { companyId }) => [{ type: 'company-ats', id: companyId }],
    }),
    upsertCompanyAtsKey: builder.mutation({
      query: ({ companyId, apiKey, provider, gemProjectId, gemUserId }) => ({
        url: `organizations/${companyId}/ats_api_key`,
        method: 'PUT',
        data: {
          ...(apiKey ? { api_key: apiKey } : {}),
          ...(provider ? { provider } : {}),
          ...(gemProjectId ? { gem_project_id: gemProjectId } : {}),
          ...(gemUserId ? { gem_user_id: gemUserId } : {}),
        },
      }),
      invalidatesTags: (_result, _error, { companyId }) => [{ type: 'company-ats', id: companyId }],
    }),
    deleteCompanyAtsKey: builder.mutation({
      query: ({ companyId }) => ({ url: `organizations/${companyId}/ats_api_key`, method: 'DELETE' }),
      invalidatesTags: (_result, _error, { companyId }) => [{ type: 'company-ats', id: companyId }],
    }),
  }),
});

export const {
  useGetCompanyAtsSyncStatusQuery,
  useGetCompanyAtsKeyQuery,
  useUpsertCompanyAtsKeyMutation,
  useDeleteCompanyAtsKeyMutation,
  useGetGemProjectsQuery,
  useGetGemUsersQuery,
} = companyAtsApi;
